import { Seo } from "@/components/layout/Seo";
import { Reveal, Overline } from "@/components/Reveal";
import { Areas } from "@/components/sections/Areas";
import { MisionVision, ConsultancyWay, SerPrinciples } from "@/components/sections/AboutValues";
import { Organizations } from "@/components/sections/Organizations";
import { FinalCta } from "@/components/sections/CallToActions";
import { useLang } from "@/context/LanguageContext";

export default function AboutPage() {
  const { t } = useLang();
  return (
    <>
      <Seo page="about" />
      <section className="pt-14 md:pt-20 pb-2" data-testid="about-header">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Reveal>
            <h1 className="font-display text-4xl md:text-6xl leading-[1.05] tracking-tight text-navy">
              {t.nav.about}
            </h1>
            <span className="block h-px w-16 bg-ser-yellow mt-8" aria-hidden="true" />
          </Reveal>
        </div>
      </section>
      <MisionVision />
      <ConsultancyWay />
      <SerPrinciples />

      <Areas />

      <section className="py-14 md:py-20 border-t border-navy/5" data-testid="geo-section">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <Reveal>
            <Overline className="justify-center">{t.aboutPage.geo.title}</Overline>
            <p className="mt-6 font-display italic text-2xl md:text-3xl leading-snug text-navy/90">{t.aboutPage.geo.text}</p>
          </Reveal>
        </div>
      </section>

      <Organizations />
      <FinalCta />
    </>
  );
}
